import { OpenAPI } from "@propertelligent/client-api";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import { UserLoginData } from "../../common/charts/Enums";
import "../platform-portal.css";

// Appends the current session's JWT as ?access_token=<jwt> and opens the path in a new tab. A normal
// navigation/window.open can't attach an Authorization header, so the backend's JwtBearerEvents.OnMessageReceived
// reads the token from the query string for /hangfire and /swagger only (see Propertelligent.Web/Program.cs).
const openWithAccessToken = (path: string) => {
  const token = sessionStorage.getItem(UserLoginData.token);
  const base = typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "";
  const url = `${base}${path}${token ? `?access_token=${encodeURIComponent(token)}` : ""}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

/**
 * Platform super-admin "Server Tools" — direct links to the Hangfire job dashboard and the Swagger/OpenAPI docs.
 * Both routes are Platform-role-only outside Local/Dev (see HangfireAuthFilter + the Swagger gate in
 * Propertelligent.Web/Program.cs); Local/Dev deployments leave them anonymously accessible, matching prior
 * behavior. Gated purely by the App.tsx Platform role branch (a Platform JWT carries no per-module permission
 * map), same as its Platform Settings siblings — no PermissionGuard.
 */
const ServerTools = () => {
  return (
    <div className="platform-portal-page">
      <div className="top-listing-header-top d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <h2 className="H2">Server Tools</h2>
      </div>

      <p className="text-muted">
        Diagnostic tools for the backend service. Outside Local/Dev these require a Platform-role session;
        each link opens in a new tab, authenticated as the current session.
      </p>

      <div className="d-flex gap-3 flex-wrap">
        <SimpleButton
          label="Open Hangfire Dashboard"
          onClick={() => openWithAccessToken("/hangfire")}
        />
        <SimpleButton
          label="Open Swagger / API Docs"
          onClick={() => openWithAccessToken("/swagger")}
        />
      </div>
    </div>
  );
};

export default ServerTools;
